import { ospThemes } from "@ospweb/sdk-ui";

import log from "logbeacon";
import { useMemoizedFn } from "ahooks";
import { OspModalType } from "@ospweb/sdk-ui/src/modal/types";
import { PricePredictionProps } from "../QuickInsights/QuickSearchNormalComponent";
import { QuickSearchNormalComponent } from "../QuickInsights";
import { QuickStartSearchItem } from "../QuickInsights/type";
import { EdgenModalCreateAble } from "../EdgenModal";
import { CategoryType } from "../QuickInsights/constants";
import { DashboardPanelType } from "@/src/hooks";
import { StockType } from "@/src/utils/stockType";

export interface QuickInsightsSearchModalProps extends PricePredictionProps {
  onClose: () => void;
  title?: string;
  onItemClick?: ({
    keyword,
    token,
    origin,
    category,
  }: {
    keyword: string;
    token: string;
    origin: QuickStartSearchItem;
    showClose?: boolean;
    category?: CategoryType;
  }) => void;
  market?: StockType;
}

export const QuickInsightsSearchModal = ({
  onItemClick,
  type = "crypto",
  sort,
  showCancel,
  onClose,
  title,
  market,
}: QuickInsightsSearchModalProps) => {
  // 处理问题数据，根据 item 生成正确格式的 questionData
  const handleQuestionData = useMemoizedFn((item: QuickStartSearchItem) => {
    return `symbol#${item.symbol}+id#${item.id || ""}`;
  });
  // Handle search item click
  const handleStartSearch = useMemoizedFn(
    async (item: QuickStartSearchItem) => {
      log.info("[文案]QuickInsightsSearchModal item:", item);
      const keyword = handleQuestionData(item);
      log.debug("[文案]Generated questionData:", keyword);
      // const token = source === "radar" && type ==="crypto" ? item.id : item.name;
      onItemClick?.({
        keyword,
        token: item.symbol || item.name,
        origin: item,
        category: item.category || undefined,
      });
    },
  );

  return (
    <QuickSearchNormalComponent
      onStartSearch={handleStartSearch}
      type={type}
      sort={sort}
      title={title}
      market={market}
      showCancel={showCancel}
      onClose={onClose}
    />
  );
};

export default QuickInsightsSearchModal;

type QuickInsightsSearchModalCreateAbleProps = Omit<
  QuickInsightsSearchModalProps,
  "onClose"
> & {
  modalProps?: OspModalType;
  dex_id?: DashboardPanelType;
  source?: "radar" | "home";
};

export const QuickInsightsSearchModalCreateAble = async (
  props: QuickInsightsSearchModalCreateAbleProps,
): Promise<{
  keyword: string;
  token: string;
  origin: QuickStartSearchItem;
  category?: CategoryType;
}> => {
  // If no custom title is provided, use the default title based on type
  const modalTitle = (
    <div className="headline_regular_s bg-background_solid_secondary pb-6">
      <span className="text-content_primary">{props.title}</span>
    </div>
  );
  const { modalProps, ...otherProps } = props;
  return new Promise((resolve) => {
    EdgenModalCreateAble.call({
      children: (
        <QuickInsightsSearchModal
          {...otherProps}
          market={props.market}
          onClose={() => EdgenModalCreateAble.end(false)}
          onItemClick={(item) => {
            EdgenModalCreateAble.end(false);
            resolve(item);
          }}
          showCancel={!modalProps?.showClose}
        />
      ),
      containerClassName:
        "max-w-full w-full md:w-[678px] md:max-h-[548px] max-h-[100vh - 60px] px-4 md:px-0 overflow-hidden",
      contentStyle: {
        borderRadius: 16,
        backgroundColor: ospThemes.colors.background_solid_secondary,
        width: "100%",
      },
      closeStyle: {
        backgroundColor: ospThemes.colors.background_solid_secondary,
      },
      title: props.title ? modalTitle : undefined,
      titleStyle: {
        backgroundColor: ospThemes.colors.background_solid_secondary,
      },
      destroyOnClose: true,
      onCancel: () => EdgenModalCreateAble.end(false),
      ...modalProps,
    });
  });
};
